import { render, staticRenderFns } from "./PembeliAlamat.vue?vue&type=template&id=8f26fbfe&scoped=true&"
import script from "./PembeliAlamat.vue?vue&type=script&lang=js&"
export * from "./PembeliAlamat.vue?vue&type=script&lang=js&"
import style0 from "./PembeliAlamat.vue?vue&type=style&index=0&id=8f26fbfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f26fbfe",
  null
  
)

export default component.exports